import {
    GET_PARTNER_NAMES,
} from '../actionTypes/partner'

export const initialState = {
    isLoading: false,
    partnerNames: []
}

const partner = (state = initialState, action) => {
    switch (action.type) {
        case GET_PARTNER_NAMES:
            return {
                ...state,
                partnerNames: action.data.length ? action.data : []
            }
        default:
            return state;
    }
}

export default partner